// extracted by mini-css-extract-plugin
export default {"cocktailName":"cocktaildisplay_cocktailName__QOLcK","cocktailImage":"cocktaildisplay_cocktailImage__3nlhw","instructions":"cocktaildisplay_instructions__nXeLA"};